const e={path:"/api/v1/users/me",method:"GET"};export{e as RefreshUser};
